export const ADD_ITEM = "cart/ADD_ITEM";
export const SET_QUANTITY = "cart/SET_QUANTITY";
export const REMOVE_ITEM = "cart/REMOVE_ITEM";
export const CLEAR = "cart/CLEAR";
export const REMOVE_UNAVAILABLE = "cart/REMOVE_UNAVAILABLE";
export const SET_DRAWER_OPEN = "cart/SET_DRAWER_OPEN";
